import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/landing/software-development/landing-banner.webp";
import Bannerfrom from "../../components/bannerfrom";
import { StaticImage } from "gatsby-plugin-image";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service on_demand_banner lp-software-banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={7} xl={7} xxl={6} className="my-auto">
            <div className="lead_orange">
              <span>Take The Lead With</span>
            </div>
            <div className="banenr_content">
              <h1 style={{ marginBottom: "10px" }}>
                The #1{" "}
                <span style={{ color: "#f47a14" }}>Software Development</span>{" "}
                Company
              </h1>
              <p>
                Building blocks of success that automates and manage your
                operations through custom software development that delivers
                success.
              </p>
            </div>
            <div className="featured-awards-main">
              <div className="featured-awards-item">
                <div className="featured-img">
                  <StaticImage
                    src="../../../images/landing/software-development/inc.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={130}
                    height={45}
                  />
                </div>
                <div className="featured-content">
                  <p>America’s Fastest Growing Private Company</p>
                </div>
              </div>
              <div className="featured-awards-item">
                <div className="featured-img">
                  <StaticImage
                    src="../../../images/landing/software-development/clutch.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={154}
                    height={45}
                  />
                </div>
                <div className="featured-content">
                  <p>Top 1000 Companies (Global)</p>
                </div>
              </div>
              <div className="featured-awards-item">
                <div className="featured-img">
                  <StaticImage
                    src="../../../images/landing/software-development/google-partner.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={111}
                    height={47}
                  />
                </div>
                <div className="featured-content">
                  <p>Average of 4.8 Stars on Google in 5+ Cities</p>
                </div>
              </div>
            </div>
          </Col>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-xxl-1"
          >
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
